/* eslint-disable import/no-unresolved */
import React, { useEffect } from 'react';
import * as getStatic from '@backpackjs/core-nextjs/get-static';
import { store } from '@backpackjs/storefront';

import ArticleTemplate from '../../templates/article';
import { PageErrorBoundary, PageHead } from '../../_components';

export const getStaticPaths = getStatic.paths.article;
export const getStaticProps = getStatic.props.article;

export default function Article({ isPreview, renderSections, ...props }) {
  const { article } = props;

  const setArticle = store.recoil.useRecoilState(store.state.article)[1];

  useEffect(() => {
    setArticle(article);
  }, [article?.handle]);

  return (
    <PageErrorBoundary>
      <PageHead page={article}>
        <ArticleTemplate {...props} renderSections={renderSections} />
      </PageHead>
    </PageErrorBoundary>
  );
}
